import { styled } from '@mui/material/styles'
import StepConnector, { stepConnectorClasses } from '@mui/material/StepConnector'

const CustomConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 10,
    left: 'calc(-50% + 12px)',
    right: 'calc(50% + 12px)'
  },
  // When active, set the line color to primary
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: '#7766B3'
    }
  },
  // When completed, set the line color to primary
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: theme.palette.primary.main
    }
  },
  // Default line style (for steps that are not reached)
  [`& .${stepConnectorClasses.line}`]: {
    borderColor: '#F1F3F4',
    borderTopWidth: 2,
    borderRadius: 1
  }
}))

export default CustomConnector
